import { Button } from 'component/Button'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { controller } from 'store/controller'
import { me } from 'store/me'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const SaveButton = observer(() => {
  const { needEmail } = store
  const { canSave } = store.profile
  const next = !me.email

  const onContinue = useLatestCallback(async () => {
    await controller.ensureUser()
    if (!needEmail) {
      controller.saveProfile()
    } else if (next) {
      controller.saveProfileOnly()
      controller.openEmailStep()
    } else {
      if (!store.profile.email.check()) return
      controller.saveProfile()
      controller.saveProfileEmail()
    }
  })

  const label = opt.stand ? i18n('Continue') : next && needEmail ? i18n('Continue') : i18n('SaveAndTryOn')

  return <Button wide upper large primary disabled={!canSave} action={onContinue}>
    {label}
  </Button>
})
